<template>

  <aside
    class="js-navbar-vertical-aside navbar navbar-vertical-aside navbar-vertical navbar-vertical-fixed navbar-expand-xl navbar-dark bg-dark navbar-vertical-aside-initialized">
    <div class="navbar-vertical-container">
      <div class="navbar-vertical-footer-offset">
        <!-- Logo -->

        <router-link :to="{ name: 'Dashboard' }" class="navbar-brand" aria-label="Front">
          <img class="navbar-brand-logo" src="@/assets/img/cpd-logo-white.png" alt="Logo"
            data-hs-theme-appearance="default" style="max-width: 12rem; min-width: 12rem;">
          <img class="navbar-brand-logo-mini" src="@/assets/img/amoirie.png" alt="Logo"
            data-hs-theme-appearance="default">
        </router-link>

        <!-- End Logo -->

        <!-- Navbar Vertical Toggle -->
        <button type="button" class="js-navbar-vertical-aside-toggle-invoker navbar-aside-toggler">
          <i class="bi-arrow-bar-left navbar-toggler-short-align"
            data-bs-template='<div class="tooltip d-none d-md-block" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>'
            data-bs-toggle="tooltip" data-bs-placement="right" title="Reduire"></i>
          <i class="bi-arrow-bar-right navbar-toggler-full-align"
            data-bs-template='<div class="tooltip d-none d-md-block" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>'
            data-bs-toggle="tooltip" data-bs-placement="right" title="Etendre"></i>
        </button>

        <!-- End Navbar Vertical Toggle -->

        <!-- Content -->
        <NavBarAdmin />
        <!-- End Content -->

        <!-- Footer -->
        <div class="navbar-vertical-footer ps-2">
          <router-link :to="{ name: 'UserAuthProfile' }" class="ps-0 ms-0 d-flex align-items-center">
            <img src="@/assets/img/cpd-profil.jpg" alt="Image" class="avatar" style="width: 40px;height: 40px;">
            <div class="ms-2">
              <b class="text-white">{{ user?.firstname }} {{ user?.lastname }}</b>
              <div class="text-muted">{{ user?.email }}</div>
            </div>
          </router-link>
        </div>
        <!-- End Footer -->
      </div>
    </div>
  </aside>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import NavBarAdmin from "./NavBar.vue"


export default {
  name: "AsideAdmin",
  components: {
    NavBarAdmin
  },
  computed: {
    ...mapFields("auth/user", {
      user: "item",
      isLoading:"isLoading"
    })
  }
}
</script>